import Vue from 'vue'
// eslint-disable-next-line import/no-named-as-default
import vueVimeoPlayer from 'vue-vimeo-player'

Vue.use(vueVimeoPlayer)
